// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"014f2e3f","453":"a157495f"}[chunkId] + ".chunk.js";
};